<template>
    <div id="app">

        <header id="renew2_header" v-if="$site.appFlag != 'b'">
            <div class="menu_block renew2_wrapper">
                <h1 class="h1">
                    <a href="/kr/">
                        <img :src="getBaseURL + 'static/renew2_img/yagish_logo_20230522.png'"
                            alt="yagish 브라우저에서 만드는 이력서, 경력기술서">
                    </a>
                </h1>
                <div class="renew2_pc">
                    <ul class="renew2_flex sub_menu" v-if="false">
                        <li class="menu_list renew2_link_toggle"><a href="https://rirekisho.yagish.jp/">일본어</a></li>
                        <li class="menu_list renew2_link_toggle"><a href="/kr/resume/company/">운영회사</a></li>
                        <li class="menu_list contact renew2_link_toggle"><a
                                href="https://docs.google.com/forms/d/e/1FAIpQLScuJov5zRsalX4r8DLn728NPyKftKOFuBYLd8c9aZcQClc7iQ/viewform">문의하기</a>
                        </li>
                    </ul>
                    <ul class="renew2_flex menu">
                        <li class="menu_list"><a href="/kr/">이력서작성</a></li>
                    </ul>
                </div>
                <div class="renew2_sp">
                    <!--
                    <ul v-if="!$firebase.isAuthenticated" class="renew2_flex renew2_sp_flex sp_loginbtn">
                        <li class="sp_menu_list"><a href="/kr/resume/login">로그인</a></li>
                        <li class="sp_menu_list"><a href="/kr/resume/mregister">회원등록</a></li>
                    </ul>
                    <div v-if="$firebase.isAuthenticated" class="renew2_mypage"><a href="/kr/resume/mypage"
                            class="on_mypage"><span v-if="getName">{{ getName }} </span><span
                                class="renew2_font_small">님</span></a></div>登録メールアドレス-->
                </div>
            </div>
        </header>

        <router-view></router-view>


        <footer id="renew2_footer">
            <div class="footer01">
                <p class="footer_txt">이력서작성</p>
                <ul class="footer_link">
                    <li><a href="/kr/company/" class="link-item">운영회사</a></li>
                    <li><a href="/kr/privacy/" class="link-item">개인정보보호방침</a></li>
                    <li><a href="/kr/secure_privacy/" class="link-item">개인정보보호정책</a></li>
                    <li><a href="/kr/terms" class="link-item">이용약관</a></li>
                    <li><a href="/kr/help" class="link-item">도움말</a></li>
                </ul>
                <img :src="getBaseURL + 'static/renew2_img/yagish_logo_20230522.png'" alt="yagish" class="footer_img">
                <a href="/kr/contact/" target="_blank" class="contact_link">문의하기</a>
            </div>
            <div class="footer02">
                <p class="footer02-txt">언어 전환</p>
                <a href="https://rirekisho.yagish.jp/" target="_blank" class="footer02-link">일본어</a>
            </div>
            <div class="footer03">
                <p>©2021-2025 Yagish Co., Ltd. All rights reserved.</p>
            </div>
        </footer>

        <footer id="renew2_footer" v-if="false">
            <div class="renew2_footer">
                <div class="renew2_wrapper footer_block">
                    <div class="renew2_flex link_block">
                        <div class="link_block__list">
                            <img :src="getBaseURL + 'static/renew2_img/logo.svg'" alt="ヤギッシュ">
                            <p class="renew2_font_small">yagish(야기슈)는 브라우저 상에서 이력서를 만들 수 있는 무료 서비스입니다.</p>
                            <a href="https://docs.google.com/forms/d/e/1FAIpQLScuJov5zRsalX4r8DLn728NPyKftKOFuBYLd8c9aZcQClc7iQ/viewform"
                                target="_blank" class="contact_link renew2_link_toggle">문의하기</a>
                        </div><!--ロゴ-->
                        <div class="link_block__container renew2_flex">
                            <ul class="link_block__list margin">
                                <li><a href="/kr/resume/">이력서작성</a></li>
                                <li><a href="/kr/resume/dl" v-if="false">이력서 다운로드</a></li>
                                <li><a href="/kr/resume/info" v-if="false">야기슈사용법</a></li>
                            </ul><!--リンクリスト1-->
                            <ul class="link_block__list">
                                <li><a href="/kr/resume/company/">운영회사</a></li>
                                <li><a href="/kr/resume/privacy/">개인정보보호방침</a></li>
                                <li><a href="/kr/resume/secure_privacy/">개인정보보호정책</a></li>
                                <li><a href="/kr/resume/terms">이용약관</a></li>
                                <li><a href="/kr/resume/help">HELP</a></li>
                            </ul><!--リンクリスト2-->
                            <!--<ul class="link_block__list">
                                <li><a href="">サイトマップ</a></li>
                            </ul>リンクリスト3-->
                        </div>
                    </div>
                    <div class="service_block" v-if="false">
                        <p class="service_block__title">서비스목록</p>
                        <div class="renew2_flex service_block__list">
                            <ul class="service_block__item">
                                <li><a href="/kr/resume/">이력서</a></li>
                                <li><a href="https://portal.yagish.jp/company/presidents-style/" target="_blank">대표자의
                                        마음가짐</a></li>
                            </ul><!--リンクリスト1-->
                            <!-- <ul class="service_block__item">
                                <li><a href="/kr/resume/quickemailhelp">야기메일</a></li>
                            </ul>リンクリスト2 -->
                            <!--<ul class="service_block__item">
                                <li><a href="">退職代行</a></li>
                                <li><a href="">赤ペン人事部長</a></li>
                            </ul>リンクリスト3-->
                        </div>
                    </div>
                </div>
                <div class="renew2_flex renew2_sp_flex" style="
                    justify-content: center;
                    margin-top: 10px;">
                    <a href="https://rirekisho.yagish.jp/" target="_blank" style="
                    margin-right: 15px;
                    color: #fff;
                    font-weight: bold;">일본어</a>
                    <a href="https://www.yagish.com/" target="_blank" style="
                    color: #fff;
                    font-weight: bold;" v-if="false">한국어</a>
                </div>
                <p class="copyright">©2021-2025 Yagish Co., Ltd. All rights reserved.</p>
            </div>
        </footer>



        <account-dialog />
        <eprint-dialog />
        <all-preview-dialog />
        <etc-dialog />
        <loginform-dialog />
        <yagish-dialog />
    </div>
</template>


<style lang="scss" src="@/assets/scss/style.scss"></style>
<style lang="css" src="@/assets/css/renew_reset.css"></style>
<style lang="css" src="@/assets/css/renew_stylesheet.css"></style>
<style lang="css" src="@/assets/css/renew_animation.css"></style>
<style lang="css" src="@/assets/css/renew_tab.css"></style>
<style lang="css" src="@/assets/css/renew_add.css"></style>

<style lang="css" src="@/assets/css/renew2_style.css"></style>
<style lang="css" src="@/assets/css/renew2_login.css"></style>

<style lang="scss" scoped>
#renew2_top .wrapper {
    width: 768px;
    margin: 0 auto;
}

#renew2_top .mv {
    background: #0F9934;
    background: #0F9934;
    color: #fff;
    font-weight: bold;
    padding: 30px 0 0;
}

#renew2_top .mv01_list {
    text-align: left;
    margin: 20px 0;
}

#renew2_top .mv01_txt {
    text-align: center;
    background: #E95B10;
    border-radius: 70px;
    padding: 5px 0;
    font-size: 1rem;
}

#renew2_top .mv02 {
    text-align: center;
    background-image: url(/kr/resume/static/renew3_img/back03.png);
    background-position: center;
    background-repeat: no-repeat;
    width: 100vw;
    margin: 0 calc(50% - 50vw);
}

#renew2_top .mv01_item {
    position: relative;
    padding-left: 30px;
}

#renew2_top .mv01_item::before {
    position: absolute;
    content: url(/kr/resume/static/renew3_img/icon_check.png);
    display: inline-block;
    width: 20px;
    height: 20px;
    top: 0;
    left: 0;
}

#renew2_top .appeal {
    background: #EDF5E8;
    padding: 50px 0;
}

#renew2_top .appeal_list {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-bottom: 30px;
}

#renew2_top .appeal_item {
    position: relative;
    background: #004D40;
    color: #fff;
    font-size: 24px;
    font-weight: bold;
    width: calc(100% / 3 - 10px);
    padding: 80px 20px 20px;
    border-radius: 20px;
    box-shadow: 5px 5px 10px 0px rgba(15, 153, 52, 0.06);
}

#renew2_top .appeal_item::after {
    position: absolute;
    content: "";
    display: inline-block;
    width: 50px;
    height: 50px;
    background-image: url(/kr/resume/static/renew3_img/icon_appeal01.png);
    background-size: contain;
    vertical-align: middle;
    top: 10px;
    right: 10px
}

#renew2_top .appeal_item02::after {
    background-image: url(/kr/resume/static/renew2_img/top/icon_appeal02.png);
}

#renew2_top .appeal_item03::after {
    background-image: url(/kr/resume/static/renew2_img/top/icon_appeal03.png);
}

#renew2_top .appeal_txt {
    text-align: center;
}

#renew2_top .format {
    padding: 50px 0 20px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
}

#renew2_top .format_item {
    display: flex;
    justify-content: space-between;
    width: calc(100% / 2 - 10px);
    background: #E95B10;
    border-radius: 20px 20px 0 20px;
    color: #fff;
    font-weight: bold;
    margin-bottom: 30px;
    box-shadow: 5px 5px 10px 0px rgba(233, 91, 16, 0.06);
}

#renew2_top .format_item:hover {
    opacity: 1;
    text-decoration: none;
    transform: scale(1.05);
}

#renew2_top .format .left {
    position: relative;
    padding: 30px;
}

#renew2_top .format .left::after {
    position: absolute;
    content: " A4\A 2장이상";
    white-space: pre;
    color: #fff;
    opacity: 0.8;
    bottom: 30px;
}

#renew2_top .format .left02::after {
    content: " A4\A 2장";
}

#renew2_top .format .left03::after {
    content: " A4";
}

#renew2_top .format_name {
    font-size: 24px;
}

#renew2_top .format_lead {
    font-size: 16px;
}

#renew2_top .format .right {
    position: relative;
}

#renew2_top .right_img {
    height: 200px;
    width: 154px;
    object-fit: cover;
    object-position: top;
}

#renew2_top .format .right::before {
    content: "";
    position: absolute;
    bottom: 0;
    right: 0;
    border-top: 80px solid transparent;
    border-right: 80px solid #E95B10;
    z-index: 100;
}

#renew2_top .format .right::after {
    position: absolute;
    content: "클릭";
    color: #fff;
    font-weight: bold;
    font-size: 20px;
    right: 8px;
    bottom: 8px;
    transform: rotate(-45deg);
    color: #fff;
    z-index: 200;
}

#renew2_top .how {
    text-align: center;
    margin-bottom: 50px;
}

#renew2_top .how_container {
    position: relative;
    background: #EDF5E8;
    margin-bottom: 50px;
    padding: 50px 0;
}

#renew2_top .how_container::before {
    position: absolute;
    content: "";
    background-image: url(/kr/resume/static/renew2_img/top/back01.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    width: 200px;
    height: 200px;
    right: 0;
}

#renew2_top .how_list {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin: 30px auto 50px;
}

#renew2_top .how_item {
    width: calc(100% / 3 - 10px);
}

#renew2_top .how_txt {
    font-weight: bold;
    color: #004D40;
    font-size: 24px;
}

#renew2_top .how_txt span {
    display: inline-block;
    color: #fff;
    background: #E95B10;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    text-align: center;
    line-height: 34px;
}

#renew2_top .how .link {
    position: relative;
    display: block;
    color: #fff;
    font-weight: bold;
    font-size: 24px;
    max-width: 300px;
    padding: 15px 0;
    margin: 0 auto;
    border-radius: 20px;
    background: #0F9934;
}

#renew2_top .how .link::after {
    position: absolute;
    content: '';
    width: 15px;
    height: 15px;
    border: 0;
    border-top: solid 3px #fff;
    border-right: solid 3px #fff;
    transform: rotate(45deg);
    top: 0;
    right: 30px;
    bottom: 0;
    margin: auto;
}

#renew2_top .how .link:hover {
    opacity: 1;
    text-decoration: none;
    transform: scale(1.05);
}

#renew2_top .cv-btn {
    position: relative;
    display: block;
    width: calc(100% - 100px);
    padding: 40px 30px 20px;
    text-align: left;
    color: #fff;
    font-weight: bold;
    font-size: 30px;
    background: #E95B10;
    border-radius: 20px;
    box-shadow: 5px 5px 10px 0px rgba(233, 91, 16, 0.06);
}

#renew2_top .btn_container {
    position: relative;
}

#renew2_top .btn_container::after {
    position: absolute;
    content: "";
    background-image: url(/kr/resume/static/renew2_img/top/kryagi03.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    width: 200px;
    height: 200px;
    right: 0;
}

#renew2_top .cv-btn span {
    position: relative;
}

#renew2_top .cv-btn span::after {
    position: absolute;
    content: '';
    width: 20px;
    height: 20px;
    border: 0;
    border-top: solid 3px #fff;
    border-right: solid 3px #fff;
    transform: rotate(45deg);
    top: 0;
    right: -20px;
    bottom: 5px;
    margin: auto;
}

#renew2_top .cv-btn:hover {
    opacity: 1;
    text-decoration: none;
    transform: scale(1.05);
}

#renew2_footer .footer01,
#renew2_footer .footer02 {
    text-align: center;
}

#renew2_footer .footer01 {
    padding: 50px 0;
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
}

#renew2_footer .footer_link {
    display: flex;
    justify-content: center;
}

#renew2_footer .link-item {
    position: relative;
    margin: 0 25px;
}

#renew2_footer .link-item::after {
    position: absolute;
    content: "|";
    color: #0F9934;
    right: -25px;
}

#renew2_footer .contact_link {
    display: block;
    position: relative;
    color: #004D40;
}

// #renew2_footer .contact_link::after{
//     position: absolute;
//     content: "";
//     background: #004D40;
//     height: 1px;
//     width: 60px;
//     bottom: 0;
//     right: calc(50% - 30px);
// }

#renew2_footer .footer02 {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #004D40;
}

#renew2_footer .footer02-txt {
    border: 1px solid #004D40;
    border-radius: 50px;
    padding: 2px 20px;
    margin-right: 10px;
}
</style>

<style lang="scss" scoped>
#renew2_footer .footer01,
#renew2_footer .footer02,
#renew2_footer .footer03 {
    text-align: center;
}

#renew2_footer .footer02 {
    padding: 20px 0;
}

#renew2_footer .footer01 {
    padding: 50px 0;
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
}

#renew2_footer .footer03 {
    text-align: center;
    padding-bottom: 10px;
}

#renew2_footer .footer_link {
    display: flex;
    justify-content: center;
}

#renew2_footer .link-item {
    position: relative;
    margin: 0 25px;
}

#renew2_footer .link-item::after {
    position: absolute;
    content: "|";
    color: #0F9934;
    right: -25px;
}

#renew2_footer .contact_link {
    display: block;
    position: relative;
    color: #004D40;
}

// #renew2_footer .contact_link::after {
//     position: absolute;
//     content: "";
//     background: #004D40;
//     height: 1px;
//     width: 60px;
//     bottom: 0;
//     right: calc(50% - 30px);
// }

#renew2_footer .footer02 {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #004D40;
}

#renew2_footer .footer02-txt {
    border: 1px solid #004D40;
    border-radius: 50px;
    padding: 2px 20px;
    margin-right: 10px;
}

// #renew2_footer .link-item:last-child:after{
//     content: none;
// }

#renew2_footer .footer_img {
    width: 150px;
    margin: 30px 0 10px;
}

#renew2_footer .contact_link:after {
    position: absolute;
    content: "" "";
    width: 10px;
    height: 10px;
    border: 0;
    border-top: 2px solid #004d40;
    border-right: 2px solid #004d40;
    top: -3px;
    right: 0;
    left: 60px;
    bottom: 0;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
    margin: auto;
}

@media screen and (max-width: 640px) {
    #renew2_top .wrapper {
        max-width: 100%;
        padding: 0 15px;
    }

    #renew2_top .appeal {
        padding-bottom: 0;
    }

    #renew2_top .appeal_item {
        width: 100%;
        padding-top: 20px;
        margin-bottom: 20px;
    }

    #renew2_top .appeal_item:last-child {
        margin-bottom: 0;
    }

    #renew2_top .format {
        padding: 50px 15px 30px;
    }

    #renew2_top .format_item {
        width: 100%;
    }

    #renew2_top .how_item {
        width: 100%;
    }

    #renew2_top .cv-btn {
        width: 100%;
    }

    #renew2_top .format .right::after {
        content: "탭하다";
        right: 2px;
        bottom: 12px;
    }

    #renew2_top .format_item {
        margin-bottom: 20px;
    }

    #renew2_top .how_container::before {
        background-image: url(/kr/resume/static/renew2_img/top/back02.png);
    }

    #renew2_footer .footer_link {
        display: block;
    }
}
</style>
<script>
import EprintDialog from '@/components/EprintDialog'
import AccountDialog from '@/components/AccountDialog'
import AllPreviewDialog from '@/components/AllPreviewDialog'
import LoginFormDialog from '@/components/LoginFormDialog'
import YagishDialog from '@/components/YagishDialog'

export default {
    components: {
        'eprint-dialog': EprintDialog,
        'account-dialog': AccountDialog,
        'all-preview-dialog': AllPreviewDialog,
        'loginform-dialog': LoginFormDialog,
        'yagish-dialog': YagishDialog
    },
    data: function () {
        return {
        }
    },
    methods: {
        checkMynabi: function () {
            if (this.$route.query.mynavi === '19xs#rrdfS234') {
                this.$yagi.isFromMynabi = 1
            }
        }
    },
    computed: {
        getName: function () {
            if (this.$firebase.user.displayName) {
                return this.$firebase.user.displayName
            } else {
                if (this.$firebase.user.email) {
                    return this.$firebase.user.email.split('@')[0]
                } else {
                    return '야기'
                }
            }
        },
        logoBaseStyle: function () {
            if (process.env.VUE_APP_MODE === 'production') {
                return {
                    fill: '#fff'
                }
            } else if (process.env.VUE_APP_MODE === 'staging') {
                return {
                    fill: '#6bff38'
                }
            } else {
                return {
                    fill: '#cc38ff'
                }
            }
        },
        getMode: function () {
            return process.env.VUE_APP_MODE
        },
        getBaseURL: function () {
            return process.env.BASE_URL
        },
        logoEyeStyle: function () {
            if (process.env.VUE_APP_MODE === 'production') {
                return {
                    fill: '#e91044'
                }
            } else if (process.env.VUE_APP_MODE === 'staging') {
                return {
                    fill: '#09bc6c'
                }
            } else {
                return {
                    fill: '#fff'
                }
            }
        },
        isTopPage: function () {
            return (this.$route.name === 'top')
        },
        isMynabi: function () {
            this.checkMynabi()
            return (this.$yagi.isFromMynabi === 1)
        },
        isEditingFormat: function () {
            return (this.$route.name === 'formatEditCard')
        },
        needsFullScreen: function () {
            return (this.$route.name === 'formatPreview')
        },
        needsFooter: function () {
            if (this.$route.name === 'formatPreview' || this.$route.name === 'formatEditCard') {
                return false
            }
            return true
        }
    }
}
</script>
